import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.51.45a.75.75 0 0 0-1.02 0 7.79 7.79 0 0 1-5.7 2.13.75.75 0 0 0-.75.54 10.54 10.54 0 0 0 .84 7.77 9.92 9.92 0 0 0 5.92 4.83c.13.04.27.04.4 0a9.92 9.92 0 0 0 5.92-4.84 10.41 10.41 0 0 0 .84-7.76.75.75 0 0 0-.75-.54A7.79 7.79 0 0 1 8.5.45Zm-6.3 6.48c-.11-.95-.06-1.91.13-2.85A9.28 9.28 0 0 0 8 2a9.28 9.28 0 0 0 5.66 2.1 9.05 9.05 0 0 1-.87 6.09A8.42 8.42 0 0 1 8 14.22a8.42 8.42 0 0 1-4.8-4.04c-.53-1-.87-2.1-1-3.25Zm8.57.1a.75.75 0 1 0-1.06-1.06L7.25 8.44l-.97-.97a.75.75 0 0 0-1.06 1.06l1.5 1.5c.3.3.77.3 1.06 0l3-3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }